import { useEffect } from "react";
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchReservationsBookingsbyLocationReport,
  initializeReservationsBookingsbyLocationReportScreen,
  setDeleteConfirmationPopupVisibility,
  exportReservationsBookingsbyLocationReport,
  setBookingsByLocationFilters,
  clearBookingsByLocationFilters,
} from "../../../redux/actions/Reservations/ReservationsBookingsbyLocationReport";
import { fetchLocationDD } from "../../../redux/actions/location";
import { fetchRateAdminNetworkDD } from "../../../redux/actions/RateAdmin/rateadminRates";
import ReservationsBookingsbyLocationReport from "../../../component/Reservations/ReservationsBookingsbyLocationReport";
import { generatePath } from "react-router-dom";
import { loadingShow } from "../../../services/PostAPI";
import { APP_URLS } from "../../../utils/constant";
import { setIsSearch } from "../../../redux/actions/common/search";
import { ProgressBar } from "primereact/progressbar";

let cachedFilters = null;

function ReservationsBookingsbyLocationReportScreen(props) {
  const {
    fetchReservationsBookingsbyLocationReport,
    initReservationsBookingsbyLocationReportScreen,
    showPageLevelLoader,
    ReservationsBookingsbyLocationReportListview,
    paginationInfo,
    screenPermissions,
    exportReservationsBookingsbyLocationReport,
    isReservationsBookingsbyLocationReportExportError,
    isReservationsBookingsbyLocationReportExportSuccess,
    isLoading,
    fetchLocationDD,
    fetchRateAdminNetworkDD,
    RateNetworkDD,
    locationDD,
    setIsSearch,
    isSearch,
    bookingsByLocationFilters,
    setBookingsByLocationFilters,
    clearBookingsByLocationFilters,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  
  // Wrapper that updates module-level cache before dispatching to Redux
  const setFiltersWithCache = (filters) => {
    cachedFilters = filters;
    setBookingsByLocationFilters(filters);
  };

  const callAPIasync = async () => {
    await fetchRateAdminNetworkDD();
    await fetchLocationDD();
  };

  useEffect(() => {
    callAPIasync();
  }, []);

  useEffect(() => {
    initReservationsBookingsbyLocationReportScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle return from detail view - preserve filters
  useEffect(() => {
    if (
      location.state?.fromDetail &&
      cachedFilters &&
      Object.keys(cachedFilters).length > 0
    ) {
      fetchReservationsBookingsbyLocationReport({
        pageNumber: location.state?.fromDetail
          ? paginationInfo?.pageNumber - 1
          : paginationInfo?.pageNumber,
        pageSize: paginationInfo?.pageSize || 10,
        sortField: "id",
        userId: localStorage.getItem("userId"),
        additinalFilter: cachedFilters,
      });
      // Clear the navigation state
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.fromDetail]);

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
      userId: localStorage.getItem("userId"),
      // Use module-level cached filters
      additinalFilter: props.additinalFilter ?? cachedFilters,
    };
    fetchReservationsBookingsbyLocationReport(newProps);
  };
  
  // Wrapper for export that uses cached filters
  const handleExportWithFilters = (payload) => {
    const exportPayload = {
      ...payload,
      additinalFilter: payload?.additinalFilter ?? cachedFilters,
    };
    exportReservationsBookingsbyLocationReport(exportPayload);
  };
  
  const handleCreateReservationsBookingsbyLocationReport = () => {
    navigate(APP_URLS.RESERVATIONS_BOOKINGBYLOCATIONREPORT.CREATE);
  };
  const editReservationsBookingsbyLocationReportRoute = (id) => {
    const path = generatePath(
      APP_URLS.RESERVATIONS_BOOKINGBYLOCATIONREPORT.EDIT,
      {
        id,
      }
    );
    navigate(path);
  };
  const viewReservationRoute = (id) => {
    navigate(`/view-reservations/${id}/view`);
  };
  const ReservationsBookingsbyLocationReportProps = {
    handleCreateReservationsBookingsbyLocationReport,
    exportReservationsBookingsbyLocationReport: handleExportWithFilters,
    isReservationsBookingsbyLocationReportExportError,
    isReservationsBookingsbyLocationReportExportSuccess,
    editReservationsBookingsbyLocationReportRoute,
    viewReservationRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchReservationsBookingsbyLocationReports: loadLazyData,
    tableData: {
      columns: ReservationsBookingsbyLocationReportListview?.columns,
      rows: ReservationsBookingsbyLocationReportListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    RateNetworkDD,
    locationDD,
    setIsSearch,
    bookingsByLocationFilters,
    setBookingsByLocationFilters: setFiltersWithCache,
    clearBookingsByLocationFilters,
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      {isLoading && renderProgressBar()}
      <ReservationsBookingsbyLocationReport
        {...ReservationsBookingsbyLocationReportProps}
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initReservationsBookingsbyLocationReportScreen: () =>
      dispatch(initializeReservationsBookingsbyLocationReportScreen()),
    fetchReservationsBookingsbyLocationReport: (payload) =>
      dispatch(fetchReservationsBookingsbyLocationReport(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    fetchRateAdminNetworkDD: (payload) =>
      dispatch(fetchRateAdminNetworkDD(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    exportReservationsBookingsbyLocationReport: (payload) =>
      dispatch(exportReservationsBookingsbyLocationReport(payload)),
    setIsSearch: (payload) => dispatch(setIsSearch(payload)),
    setBookingsByLocationFilters: (filters) =>
      dispatch(setBookingsByLocationFilters(filters)),
    clearBookingsByLocationFilters: () =>
      dispatch(clearBookingsByLocationFilters()),
  };
};

//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "isLoading"
    ),
    isSearch: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "isSearch"
    ),
    isReservationsBookingsbyLocationReportCreateSuccess:
      selectFromReservationsBookingsbyLocationReportReducer(
        state,
        "isReservationsBookingsbyLocationReportCreateSuccess"
      ),
    ReservationsBookingsbyLocationReportListview:
      selectFromReservationsBookingsbyLocationReportReducer(
        state,
        "ReservationsBookingsbyLocationReportListview"
      ),
    showPageLevelLoader: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "isFetchingGridData"
    ),
    RateNetworkDD: selectFromRateAdminRatesReducer(state, "RateNetworkDD"),
    locationDD: selectFromLocationReducer(state, "locationDD"),
    isReservationsBookingsbyLocationReportExportError:
      selectFromReservationsBookingsbyLocationReportReducer(
        state,
        "isReservationsBookingsbyLocationReportExportError"
      ),
    isReservationsBookingsbyLocationReportExportSuccess:
      selectFromReservationsBookingsbyLocationReportReducer(
        state,
        "isReservationsBookingsbyLocationReportExportSuccess"
      ),
    bookingsByLocationFilters: selectFromReservationsBookingsbyLocationReportReducer(
      state,
      "bookingsByLocationFilters"
    ),
    ...ownProps,
  };
};

const selectFromReservationsBookingsbyLocationReportReducer = (state, path) => {
  return selectReservationsBookingsbyLocationReportReducer(state)[path];
};

const selectReservationsBookingsbyLocationReportReducer = ({
  ReservationsBookingsbyLocationReportReducer,
}) => {
  return ReservationsBookingsbyLocationReportReducer;
};

// For Network
const selectFromRateAdminRatesReducer = (state, path) => {
  return selectRateAdminRatesReducer(state)[path];
};

const selectRateAdminRatesReducer = ({ rateadminRatesReducer }) => {
  return rateadminRatesReducer;
};
//Location
const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationsBookingsbyLocationReportScreen);
